package com.nonopn.skywatcher.common.app.pages.map.view.alerts

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Warning
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.weather.EtaHolder
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.alert_title_threat_approaching
import com.nonopn.skywatcher.common.app.res.alert_title_threat_overhead
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.LocalSubFrame
import com.nonopn.skywatcher.design.utils.WindowType
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun ShowETA(
    modifier: Modifier,
    eta: EtaHolder
) {
    val isTiny = when (LocalSubFrame.current) {
        WindowType.SMARTPHONE_TINY -> true
        WindowType.SMARTPHONE -> true
        WindowType.PHABLET -> false
        WindowType.TABLET -> false
    }

    if (isTiny) {
        Column(
            modifier = modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ShowEtaInformation(eta, true)
        }
        return
    }

    Row(
        modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Icon(
            modifier = Modifier.width(64.dp).height(64.dp),
            painter = rememberVectorPainter(Icons.Default.Warning),
            contentDescription = "",
            tint = AppColor.Yellorange
        )

        Column(
            modifier = Modifier,
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            ShowEtaInformation(eta)
        }
    }
}

@Composable
private fun ShowEtaInformation(eta: EtaHolder, showIcon: Boolean = false) {
    val message = if (eta.overhead) {
        Res.string.alert_title_threat_overhead
    } else {
        Res.string.alert_title_threat_approaching
    }
    Row(
        modifier = Modifier.padding(bottom = 8.dp),
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        if (showIcon) {
            Icon(
                painter = rememberVectorPainter(Icons.Default.Warning),
                contentDescription = "",
                tint = AppColor.Yellorange
            )
        }

        TextNormal(
            modifier = if (showIcon) {
                Modifier.weight(1.0f)
            } else {
                Modifier
            },
            text = message.localized(),
            fontSize = LocalFontSizes.current.map.alertBannerTitle,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center
        )
    }

    if (!eta.overhead) {
        val displayedMinutes = if (eta.expectedMinutes > 90) {
            "> 90min"
        } else {
            "${eta.expectedMinutes}min"
        }

        Row(modifier = Modifier) {
            TextNormal(
                text = "ETA $displayedMinutes",
                fontSize = LocalFontSizes.current.map.alertBannerETA,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center
            )
        }
    }
}

@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun ShowTinyPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true,
        frameType = WindowType.SMARTPHONE_TINY
    ) {
        ShowETA(
            Modifier.fillMaxWidth().height(150.dp),
            EtaHolder.fake
        )
    }
}

@HotPreview(widthDp = 1200, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 150, darkMode = false)
@Composable
private fun ShowLargePreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true,
        frameType = WindowType.TABLET
    ) {
        ShowETA(
            Modifier.fillMaxWidth().height(150.dp),
            EtaHolder.fake
        )
    }
}